export async function geocodeLocation( query ) {
	const params = new URLSearchParams( {
		q: query,
		access_token: window.mapboxgl.accessToken,
		autocomplete: 'false',
		proximity: '4.4025,51.2194',
		language: document.documentElement.lang ?? 'en',
		limit: '1',
		types: 'address,street,place,locality,postcode',
		format: 'geojson',
	} );

	const url = new URL( 'https://api.mapbox.com/search/geocode/v6/forward' );
	url.search = params.toString();

	const response = await fetch( url );
	if ( !response.ok ) {
		throw new Error(
			`Mapbox geocoding request failed with status ${response.status}`
		);
	}

	const data = await response.json();

	return {
		coordinates: data?.features?.[0]?.geometry?.coordinates,
		full_address: data?.features?.[0]?.properties?.full_address,
	};
}
